<template>
  <v-container class="solution-details">
    <div
      style="display: flex; gap: 24px; flex-wrap: wrap; align-items: flex-start"
    >
      <v-card
        id="solution-goals"
        text-color="primary"
        elevation="0"
        style="flex: 1; min-width: 500px"
      >
        <v-card-title class="title">
          <v-icon left>mdi-bullseye-arrow</v-icon>
          Goals
        </v-card-title>
        <GoalsEdition :selectedProblem="problemId" />
      </v-card>

      <v-card
        id="solution-requirements"
        text-color="primary"
        elevation="0"
        style="flex: 1; min-width: 500px"
      >
        <v-card-title class="title">
          <v-icon left>mdi-database-search</v-icon>
          Data and Simulation Requirements
        </v-card-title>
        <TestRequirements :selectedProblem="problemId" />
      </v-card>
    </div>

    <v-card id="solution-model-risk" text-color="primary" elevation="0">
      <v-card-title class="title">
        <v-icon left>mdi-chart-line</v-icon>
        Accepted Model Risk
      </v-card-title>
      <InteractiveSquare :selectedProblem="problemId" />
    </v-card>

    <v-card
      id="solution-simulation-tools"
      text-color="primary"
      elevation="0"
      class="final-action-card"
    >
      <v-card-title class="title final-action-title">
        <v-icon left size="large">mdi-rocket-launch</v-icon>
        Recommended Solutions & Tools
      </v-card-title>
      <div class="final-action-content">
        <SimulationRecommendationSelection
          :selectedProblem="problemId"
          :selectedLab="livingLab"
        />
      </div>
    </v-card>

    <DownloadDataBase :selectedProblem="problemId" />
  </v-container>
</template>

<script>
import { defineComponent } from "vue";
import InteractiveSquare from "@/components/InteractiveSquare.vue";
import TestRequirements from "@/components/requirements/TestRequirements.vue";
import GoalsEdition from "@/components/goals/GoalsEdition.vue";
import DownloadDataBase from "@/components/DownloadDataBase.vue";
import SimulationRecommendationSelection from "@/components/SimulationRecommendationSelection.vue";

export default defineComponent({
  name: "SolutionDetails",
  components: {
    InteractiveSquare,
    TestRequirements,
    GoalsEdition,
    DownloadDataBase,
    SimulationRecommendationSelection,
  },
  props: {
    problemId: {
      type: [String, Number],
      required: true,
    },
    livingLab: {
      type: [String, Number],
      default: null,
    },
  },
});
</script>

<style scoped>
.solution-details {
  width: 100%;
}

#solution-simulation-tools.final-action-card {
  background: linear-gradient(
    135deg,
    var(--secondaryColorLighter) 0%,
    var(--backgroundColor) 100%
  ) !important;
  border: 3px solid var(--primaryColor);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#solution-simulation-tools.final-action-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.8),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.final-action-title {
  font-weight: 900 !important;
  font-size: 1.8rem !important;
  letter-spacing: 0.5px;
  padding: 24px !important;
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  text-transform: uppercase;
}

.final-action-content {
  padding: 24px;
  border-radius: 8px;
  margin: 12px;
  width: 100%;
  box-sizing: border-box;
}
</style>
